import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg, fmt, fmtDate } from "@/lib/api";
import { Chip, Empty } from "@/components/ui-bits";
import { SCALES } from "@/components/CheckIn";
import { CheckinTrends } from "@/components/CheckinTrends";

const DeloadChip = ({ detail, onApplied }) => {
  const [busy, setBusy] = useState(false);
  const [plans, setPlans] = useState([]);
  const [planId, setPlanId] = useState("");
  const d = detail.deload;
  const injuries = detail.injuries || [];
  useEffect(() => { if (!d.applied) api.get("/recovery-plans").then((r) => { setPlans(r.data); const match = r.data.find((p) => (p.injuries || []).some((t) => injuries.includes(t))); setPlanId(match?.id || r.data.find((p) => p.builtin)?.id || r.data[0]?.id || ""); }); }, [d.applied]); // eslint-disable-line react-hooks/exhaustive-deps
  const apply = async () => {
    setBusy(true);
    try { const r = await api.post(`/clients/${detail.id}/deload/apply`, { planId: planId || null }); toast.success(`Recovery session set for ${fmt(r.data.sessionStartAt)} — client notified`); onApplied?.(); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  const rs = detail.sessions?.find((s) => s.id === d.applied?.sessionId);
  return (
    <div className="note" style={{ cursor: "default", marginBottom: 6, borderLeftColor: d.applied ? "var(--accent,var(--ink))" : "var(--bad,#b42318)" }} data-testid="client-deload-chip">
      <b>{d.applied ? "Deload applied ✓" : "⚠ Deload suggested"}</b> — soreness {d.soreness[0]}/5, {d.soreness[1]}/5 two weeks running.
      {d.applied
        ? <span data-testid="deload-applied"> Recovery session on {fmt(d.applied.sessionStartAt)}{d.applied.planName ? ` · ${d.applied.planName}` : ""}{rs?.recoveryTotal != null && <span className="num" data-testid="deload-recovery-progress"> · {rs.recoveryDone}/{rs.recoveryTotal} items done</span>}.</span>
        : <span> Swap the next session for a lighter one:
            <select value={planId} onChange={(e) => setPlanId(e.target.value)} style={{ margin: "0 8px", width: "auto", display: "inline-block" }} data-testid="deload-plan-select">{plans.map((p) => <option key={p.id} value={p.id}>{p.name} · {p.items.length} items{(p.injuries || []).some((t) => injuries.includes(t)) ? " · matches injury" : ""}</option>)}</select>
            <button className="btn sm" disabled={busy || !planId} onClick={apply} data-testid="apply-deload-button">{busy ? "Applying…" : "Apply deload"}</button></span>}
    </div>
  );
};

export const ClientWeek = ({ detail, onChanged }) => {
  const pp = detail.programProgress;
  const c = detail.checkin;
  return (
    <div className="excard" data-testid="client-week-strip">
      <div className="st" style={{ marginBottom: 6 }}>This week{pp ? ` · from ${fmtDate(pp.weekStart)}` : ""}</div>
      <div className="ss" style={{ marginBottom: 4 }}>Weekly plan {pp ? `· ${pp.name}` : ""}</div>
      {!pp && <Empty>No program assigned — pick one in the Exercises tab.</Empty>}
      {pp && (
        <>
          <div className="daystrip" data-testid="program-progress-days">
            {pp.days.map((d, i) => { const pct = d.total ? Math.round((d.done / d.total) * 100) : 0; return (
              <div className="dayprog" key={i} data-testid={`program-progress-day-${i}`}>
                <div className="ss" style={{ display: "flex", justifyContent: "space-between" }}><span>{d.name}</span><b className="num" style={{ color: "var(--ink)" }}>{d.done}/{d.total}</b></div>
                <div className="rbar" style={{ marginTop: 4 }}><i style={{ width: `${pct}%` }} /></div>
              </div>); })}
          </div>
          <div className="ss" style={{ marginTop: 6 }} data-testid="program-progress-summary">
            {pp.done}/{pp.total} exercises ticked off{pp.lastActivity ? ` · last activity ${fmt(pp.lastActivity, { weekday: "short", hour: "2-digit", minute: "2-digit" })}` : " · no activity yet this week"}
          </div>
        </>
      )}
      <div className="ss" style={{ margin: "12px 0 4px" }}>Weekly check-in</div>
      {detail.deload && <DeloadChip detail={detail} onApplied={onChanged} />}
      {!c && <div className="ss" data-testid="client-checkin-missing">Not checked in yet this week.</div>}
      {c && (
        <div data-testid="client-checkin">
          <div className="hl">
            {SCALES.map(([k, label, words]) => <Chip key={k} cls={(k === "soreness" ? c[k] >= 4 : c[k] <= 2) ? "bad" : "gray"} label={`${label} ${c[k]}/5 · ${words[c[k] - 1]}`} />)}
            {c.flags.map((f) => <Chip key={f} cls="bad" label={`⚠ ${f}`} />)}
          </div>
          {c.note && <div className="ss" style={{ marginTop: 4 }}>“{c.note}”</div>}
        </div>
      )}
      <CheckinTrends items={detail.checkinTrend} />
    </div>
  );
};
